import { render, staticRenderFns } from "./PlayerConversationInvited.vue?vue&type=template&id=94d2118a&scoped=true&"
import script from "./PlayerConversationInvited.vue?vue&type=script&lang=js&"
export * from "./PlayerConversationInvited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d2118a",
  null
  
)

export default component.exports